/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminWhitelabelResponseV4SslCertificateFromJSON, InternalAdminWhitelabelResponseV4SslCertificateToJSON, } from './InternalAdminWhitelabelResponseV4SslCertificate';
/**
 * @export
 */
export const InternalAdminWhitelabelResponseV4StatusEnum = {
    Pending: 'pending',
    Validated: 'validated',
    Failed: 'failed',
    Processing: 'processing'
};
/**
 * Check if a given object implements the InternalAdminWhitelabelResponseV4 interface.
 */
export function instanceOfInternalAdminWhitelabelResponseV4(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('clientFqdn' in value) || value['clientFqdn'] === undefined)
        return false;
    if (!('hivebriteFqdn' in value) || value['hivebriteFqdn'] === undefined)
        return false;
    if (!('hivebriteFqdnPath' in value) || value['hivebriteFqdnPath'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('sslCertificate' in value) || value['sslCertificate'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelResponseV4FromJSON(json) {
    return InternalAdminWhitelabelResponseV4FromJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'clientFqdn': json['client_fqdn'],
        'hivebriteFqdn': json['hivebrite_fqdn'],
        'hivebriteFqdnPath': json['hivebrite_fqdn_path'],
        'status': json['status'],
        'sslCertificate': InternalAdminWhitelabelResponseV4SslCertificateFromJSON(json['ssl_certificate']),
    };
}
export function InternalAdminWhitelabelResponseV4ToJSON(json) {
    return InternalAdminWhitelabelResponseV4ToJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'client_fqdn': value['clientFqdn'],
        'hivebrite_fqdn': value['hivebriteFqdn'],
        'hivebrite_fqdn_path': value['hivebriteFqdnPath'],
        'status': value['status'],
        'ssl_certificate': InternalAdminWhitelabelResponseV4SslCertificateToJSON(value['sslCertificate']),
    };
}
